<template>
  <el-tabs v-model="activeLanguage">
    <el-tab-pane v-for="domain in domains"
                 :key="domain.language"
                 :label="`Text ${domain.language.toUpperCase()}`"
                 :name="domain.language">
      <card v-for="text in editableTexts"
            :title="text.alias === 'video_title' ? 'Заголовок основного відео (необов’язково)' : text.alias"
            :key="text.alias">
        <base-input v-if="['video_review', 'video', 'video_title'].includes(text.alias)">
            <textarea :rows="text.alias === 'video_title' ? 1 : 4" cols="80"
                      :maxlength="text.alias === 'video_title' ? 200 : undefined"
                      class="form-control"
                      :placeholder="text.alias"
                      v-model="text.text"
                      @input="text.alias === 'video' && clearVideoTitle()"
            ></textarea>
        </base-input>
        <ckeditor v-else-if="activeLanguage === domain.language"
                  v-model="text.text"
                  :config="{ allowedContent: true }">
        </ckeditor>
      </card>
      <base-button type="primary"
                   class="mt-16"
                   @click="save()">Save clinic's texts</base-button>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import APIClinics from '@/api/modules/clinics';
import { resultErrorOf, resultErrorMessage } from '@/api/helpers/resultError';
import { mapState } from 'vuex';

  export default {
    data: () => ({
      activeLanguage: null,
      domainTexts: [],
      loadSequence: 0,
      loadedLanguage: null,
      defaultTexts: [
        { alias: 'video', text: ''},
        { alias: 'video_title', text: ''},
        { alias: 'video_review', text: ''},
        { alias: 'txt_official_represent', text: ''},
      ],
    }),
    computed: {
      ...mapState('cmsApiCatalogs', ['domains']),
      editableTexts() { return this.domainTexts.filter(text => this.defaultTexts.some(item => item.alias === text.alias)); },
    },
    watch: {
      activeLanguage() {
        this.getDomainTextsEvent({ lang: this.activeLanguage, clinicId: this.$route.params.clinicId });
      },
    },
    created() {
      this.activeLanguage = this.domains[0].language;
    },
    methods: {
      clearVideoTitle() {
        const title = this.domainTexts.find(text => text.alias === 'video_title');
        if (title) title.text = '';
      },
      async save() {
        if (this.loadedLanguage !== this.activeLanguage) return;
        const lang = this.loadedLanguage;
        const texts = this.domainTexts.map(item => ({ ...item }));
        this.$store.dispatch('setLoader', true);

        try {
          const response = await APIClinics.updateClinicDomainTexts({
            lang,
            clinicId: this.$route.params.clinicId,
            data: {
              texts,
            },
          });

          // A refused write comes back as HTTP 200 with an error body, so it never reaches the
          // catch below — without this check the editor was told "Saved" and lost the change.
          const error = resultErrorOf(response);
          if (error) {
            this.$notify({ type: 'warning', title: resultErrorMessage(error) });

            return;
          }

          this.$notify({ type: 'success', title: 'Saved' });
        } catch (e) {
          this.$notify({ type: 'warning', title: 'Save Failed' });
        } finally {
          this.$store.dispatch('setLoader', false);
        }
      },
      getDomainTextsEvent(params) {
        const sequence = ++this.loadSequence;
        this.loadedLanguage = null;
        this.domainTexts = [];
        this.$store.dispatch('setLoader', true);
        return APIClinics.getClinicDomainTexts(params).then((response) => {
          if (sequence !== this.loadSequence) return;
          if (resultErrorOf(response) || !response.data || !Array.isArray(response.data.texts)) {
            this.$notify({ type: 'warning', title: 'Не вдалося прочитати тексти. Оновіть вкладку перед збереженням.' });
            return;
          }
          if (response.data && Array.isArray(response.data.texts)) {
            this.domainTexts = this.defaultTexts.map(defaultText => {
              let findingEntityText = response.data.texts.find(domainText => domainText.alias === defaultText.alias);
              return {
                alias: defaultText.alias,
                text: findingEntityText && typeof findingEntityText.text === 'string' ? findingEntityText.text : '',
              };
            });
            this.domainTexts.push(...response.data.texts.filter(text => !this.defaultTexts.some(item => item.alias === text.alias)));
          } else {
            this.domainTexts = this.defaultTexts.map(item => ({ ...item }));
          }
          this.loadedLanguage = params.lang;
        }).catch(() => { if (sequence === this.loadSequence) this.$notify({ type: 'warning', title: 'Не вдалося прочитати тексти.' }); }).finally(() => { if (sequence === this.loadSequence) this.$store.dispatch('setLoader', false); });
      },
    },
  };
</script>
